
import React from "react";
// @ts-ignore
import {ReactBingmaps} from "react-bingmaps";

const svgString = '<svg width="50" height="50" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path d="M67 34C67 52.2254 52.2254 67 34 67C15.7746 67 1 52.2254 1 34C1 15.7746 15.7746 1 34 1C52.2254 1 67 15.7746 67 34Z" fill="white" stroke="#449DF7" stroke-width="2"/>\n' +
    '<path d="M33.372 51.9932C33.2372 51.9722 33.1087 51.92 32.996 51.8402C32.8832 51.7604 32.7891 51.6553 32.7205 51.5324L23.7242 36.1731C22.5927 34.2835 21.995 32.0991 22 29.8708C22.0329 26.7107 23.259 23.6916 25.4121 21.4691C27.5651 19.2466 30.4714 18 33.5 18C36.5285 18 39.4348 19.2466 41.5879 21.4691C43.741 23.6916 44.9671 26.7107 44.9999 29.8708C45.0067 32.0345 44.4445 34.1586 43.3746 36.012L34.3513 51.5126C34.2779 51.6468 34.1748 51.7607 34.0506 51.8448C33.849 51.9768 33.6081 52.0271 33.3733 51.9861L33.372 51.9932ZM27.7497 29.8708C27.7491 31.0579 28.086 32.2184 28.7176 33.2057C29.3492 34.193 30.2472 34.9626 31.298 35.4173C32.3488 35.8719 33.5052 35.9912 34.621 35.7599C35.7367 35.5287 36.7617 34.9574 37.5663 34.1182C38.3708 33.279 38.9188 32.2097 39.141 31.0455C39.3631 29.8813 39.2493 28.6745 38.8141 27.5777C38.3789 26.481 37.6418 25.5436 36.696 24.884C35.7502 24.2245 34.6382 23.8724 33.5007 23.8724C32.7466 23.8713 31.9996 24.0252 31.3025 24.3254C30.6055 24.6255 29.9719 25.066 29.4379 25.6217C28.904 26.1775 28.4802 26.8375 28.1908 27.5641C27.9013 28.2908 27.7519 29.0698 27.751 29.8567L27.7497 29.8708Z" fill="#449DF7"/>\n' +
    '</svg>\n'

export interface BingMapsProps {
    title?: string;
    longitude?: string;
    latitude?: string;
    description?: string;
}

//  const NSPM_ADMIN_CONFIG = {
//        center: [36.8739433,-76.3070599],
//        title: "NSPM Admin",
//        description: "PM10",
//  }
//
// const NSPM_HRSD_PRIMARY_CONFIG = {
//     center: [36.881694,-76.320500],
//     title: "NSPM HRSD Primary",
//     description: "PM10",
// }


export const BingMaps: React.FC<BingMapsProps> = ({title="NSPM HRSD Primary",
						   longitude=-76.320500,
                                                   latitude=36.881694,
                                                   description="PM 10"}) => {
    return (

        <ReactBingmaps
            bingmapKey="ApOZNpl31qcP2DRnLJ1VC4VESfGRDghcUjU9SFO0P0nu4ciUYp_H2mOfjrMMrSCf"
            center={[latitude,longitude]}
            mapTypeId={"aerial"}
            zoom={14}
            infoboxesWithPushPins={[
                {
                    "location": [latitude,longitude],
                    "addHandler": "click", //on mouseover the pushpin, infobox shown
                    "infoboxOption": {title, description},
                    "pushPinOption": {title, description, icon: svgString},

                }]}
             ></ReactBingmaps>

    );
};
